export default IconSquarePlus2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-square-plus-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5" />
  <path d="M16 19h6" />
  <path d="M19 16v6" />
</svg>`;